import { render } from "./MyProfileMenu.vue?vue&type=template&id=163cdb9a"
import script from "./MyProfileMenu.vue?vue&type=script&lang=ts"
export * from "./MyProfileMenu.vue?vue&type=script&lang=ts"

import "./MyProfileMenu.vue?vue&type=style&index=0&id=163cdb9a&lang=scss"
script.render = render

export default script